import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../../models/api-url.model';
import { ApiService } from '../../services/api';
import { UserForm } from './ms-graph.types';

@Injectable({
  providedIn: 'root',
})
export class MSGraphService {
  private readonly apiService = inject(ApiService);

  /** @deprecated Not used - possibly out of date. */
  getEntraUserProfile(): Observable<any> {
    return this.apiService.get(`${api.usersURL}`);
  }

  /** @deprecated Not used - possibly out of date. */
  inviteEntraUser(payload: any): Observable<any> {
    return this.apiService.post(`${api.usersURL}`, payload);
  }

  /** @deprecated Not used - possibly out of date. */
  resendEntraInvitation(email: string): Observable<any> {
    return this.apiService.post(`${api.usersURL}/resend-invitation`, { email });
  }

  updateEntraUser(userEntraId: string, payload: UserForm): Observable<any> {
    return this.apiService.put(`${api.usersURL}/${userEntraId}`, payload);
  }

  /** @deprecated Not used - possibly out of date. */
  deactivateEntraUser(userEntraId: string, sfUserId: string): Observable<any> {
    return this.apiService.put(`${api.usersURL}/${userEntraId}/deactivate`, {
      sfUserId,
    });
  }

  /** @deprecated Not used - possibly out of date. */
  cancelEntraInvitation(
    invitationId: string,
    sfUserId: string,
  ): Observable<any> {
    return this.apiService.put(
      `${api.usersURL}/cancel-invitation/${invitationId}`,
      { sfUserId },
    );
  }
}
